// extracted by mini-css-extract-plugin
export var news = "styles-module--news--IUxOF";
export var news_title = "styles-module--news_title--11zkc";
export var news_subscribe = "styles-module--news_subscribe--y4-HR";